module.exports = __webpack_public_path__ + "img/fsg_soccer.21dfe28e.svg";